import { createContext, useState, useMemo, useContext, useEffect } from "react"

export const ThemeContext = createContext({
  setFontFamily: () => {},
  fontFamily: "Poppins Regular",
  setFontSize: () => {},
  fontSize: "18px",
  bgColor: "white",
  setBgColor: () => {},
})

export const useThemeContext = () => {
  const context = useContext(ThemeContext)
  if (context === undefined) {
    throw new Error(
      "useThemeContext must be used within a ThemeContextProvider"
    )
  }
  return context
}

export default function ThemeContextProvider({ children }) {
  const [fontFamily, setFontFamily] = useState("Poppins Regular")
  const [fontSize, setFontSize] = useState("18px")
  const [bgColor, setBgColor] = useState("white")
  const [mode, setMode] = useState("light")

  useEffect(() => {
    if (mode === "dark") {
      document.documentElement.classList.add("dark-mode")
    } else {
      document.documentElement.classList.remove("dark-mode")
    }
  }, [mode])

  const contextValue = useMemo(
    () => ({
      setFontFamily,
      setFontSize,
      setBgColor,
      setMode,
      fontFamily,
      fontSize,
      bgColor: mode === "light" ? bgColor : "#1d2329",
      mode,
    }),
    [fontFamily, fontSize, bgColor, mode]
  )

  return (
    <ThemeContext.Provider value={contextValue}>
      {children}
    </ThemeContext.Provider>
  )
}
